<template lang="html">
  <div class="auth-form-transparent text-left p-3">
    <div class="brand-logo">
      <img src="/img/logo.png" alt="logo"> TradingApp
    </div>
    <h4>{{lang=="ru"?"Восстановление пароля":"Password reset"}}</h4>
    <h6 class="font-weight-light">{{lang=="ru"?"Введите новый пароль":"Enter a new password"}}</h6>
    <h6 class="font-weight-light" style='color: red' :class='errorText ? "" : "invisible"'>{{errorText}}</h6>
    <form class="pt-3">
      <div class="form-group">
        <label>{{lang=="ru"?"Пароль":"Password"}}</label>
        <div class="input-group">
          <div class="input-group-prepend bg-transparent">
            <span class="input-group-text bg-transparent border-right-0">
              <i class="fa fa-lock text-primary"></i>
            </span>
          </div>
          <input type="password" class="form-control form-control-lg border-left-0 input-auth" v-model="password" :placeholder="password_text" v-on:keyup.enter='password_reset'>
        </div>
      </div>
      <div class="form-group">
        <label>{{comfirm_text}}</label>
        <div class="input-group">
          <div class="input-group-prepend bg-transparent">
            <span class="input-group-text bg-transparent border-right-0">
              <i class="fa fa-lock text-primary"></i>
            </span>
          </div>
          <input type="password" class="form-control form-control-lg border-left-0" v-model="password_confirmation" :placeholder="comfirm_text" v-on:keyup.enter='password_reset'>
        </div>
      </div>
      <div class="mt-3">
        <a class="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn" v-on:click="password_reset" style="color:white">{{lang=="ru"?"Сбросить":"RESET"}}</a>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  data () {
    return {
      password: '',
      password_confirmation: '',
      errorText: null,
      lang:'en',
      password_text:"Password",
      comfirm_text:"Confirm password"
    }
  },
  created (){
    this.lang = this.$cookie.get('lang');
    if(this.lang=="ru"){
      this.password_text="Пароль"
      this.comfirm_text="Подтвердите пароль"
    }
  },
  methods: {
    password_reset () {
      this.errorText = null
      this.axios.post('/reset_password', {
        token: this.$route.params.token,
        password: this.password,
        password_confirmation: this.password_confirmation
      }).then((response) => {
        response = response.data
        console.log(response)
        if (response.success) {
          this.$router.push('/login')
        } else {
          this.errorText = response.message
        }
      })
    }
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/ForgotPasswordStep3.vue